// ===== Header.js =====
import React from 'react';
import { NavLink, useLocation, useParams } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const { id } = useParams();

  // ヘッダーを非表示にするパスのリスト
  const hidePaths = [
    '/reserve/diabetes/4', 
    '/reserve/hyperlipidemia/3', 
    '/reserve/gout/2', 
    '/reserve/hypertension/1', 
    '/medichat/chat',
    '/medichat/mypage',
    '/doctor/profile',
    '/doctor/shifts'
  ];

  // 現在のパスが非表示リストに含まれているかチェック
  if (hidePaths.includes(location.pathname)) {
    return null; // ヘッダーを非表示にする
  }

  const renderMypageHeader = (activePage) => (
    <div className="mypage_header">
      <NavLink to="/mypage/reservation" className={activePage === 'reservation' ? 'mypage_header_content_active' : 'mypage_header_content'}>
        <h1 className="header_title_h1">予約中</h1>
      </NavLink>
      <NavLink to="/mypage/history" className={activePage === 'history' ? 'mypage_header_content_active' : 'mypage_header_content'}>
        <h1 className="header_title_h1">受診歴</h1>
      </NavLink>
      <NavLink to="/mypage/other" className={activePage === 'other' ? 'mypage_header_content_active' : 'mypage_header_content'}>
        <h1 className="header_title_h1">基本情報</h1>
      </NavLink>
    </div>
  );

  const renderMedicineHeader = (activePage) => (
    <div className="mypage_header">
      <NavLink
        to="/medicine"
        className={activePage === 'medicine' ? 'mypage_header_content_active' : 'mypage_header_content'}
      >
        <h1 className="header_title_h1">処方履歴</h1>
      </NavLink>
      <NavLink
        to="/medicine/inspection"
        className={activePage === 'inspection' ? 'mypage_header_content_active' : 'mypage_header_content'}
      >
        <h1 className="header_title_h1">検査履歴</h1>
      </NavLink>
    </div>
  );

  const renderHeaderContent = () => {
    // パスが '/mypage/payment' の場合に、renderMypageHeader を返さないように修正
    if (location.pathname.startsWith('/reserve/confirm') || location.pathname.startsWith('/reserve/register')) {
      return (
          <h1 className="header_title_h1">予約確認</h1>
      );
    }
    if (location.pathname.startsWith('/mypage/payment')) {
      return (
          <h1 className="header_title_h1">お支払い</h1>
      );
    }

    if (location.pathname.startsWith('/reserve/diagnose')) {
      return (
          <h1 className="header_title_h1" style={{fontSize:'1.2rem'}}>初診問診</h1>
      );
    }

    if (location.pathname.startsWith('/reserve/rediagnose')) {
      return (
          <h1 className="header_title_h1" style={{fontSize:'1.2rem'}}>再診問診</h1>
      );
    }

    if (location.pathname.startsWith('/mypage')) {
      // マイページの各タブに応じたヘッダーを表示
      if (location.pathname.includes('/reservation')) return renderMypageHeader('reservation');
      if (location.pathname.includes('/history')) return renderMypageHeader('history');
      // `mypage/payment` は先に処理されているので、ここでは不要
      if (location.pathname.includes('/other')) return renderMypageHeader('other');
    }

    if (location.pathname.startsWith('/medicine')) {
      // `/medicine` と `/medicine/inspection` の場合に対応
      if (location.pathname === '/medicine') return renderMedicineHeader('medicine');
      if (location.pathname === '/medicine/inspection') return renderMedicineHeader('inspection');
    }

    switch (location.pathname) {
      case '/reserve/no_smoking':
        return (
            <h1 className="header_title_h1">痛風治療 / オンライン診療</h1>
        );
      case '/reserve/snore':
        return (
            <h1 className="header_title_h1">高血圧</h1>
        );
      case '/reserve/diet':
        return (
            <h1 className="header_title_h1">高脂血症治療</h1>
        );
      default:
        return (
          <NavLink to="/reserve">
            <img src="/logo_service.png" alt="CureNow" className="fixed-header_image" />
          </NavLink>
        );
    }
  };

  return (
    <header className="fixed-header">
      {renderHeaderContent()}
    </header>
  );
};

export default Header;